export default "__VITE_ASSET__Bv6DkCv8__"